export default {
    price: {
        /**
         * @description calcula el precio de un producto
         * @param {number} price precio original del producto en su moneda local
         * @returns {string} precio final
         */
        get: (price) => {
            if (!price)
                return 0

            return (Math.round(price * 1.15 * 100) / 100)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        /**
         * @description calcula un descuento a un precio en moneda local
         * @param {number} price precio original del producto en su moneda local 
         * @param {number} discount descuento a aplicar (descuento <= 1)
         * @returns {string} precio final con descuento
         */
        discount: (price, discount) => {
            if (!price)
                return 0

            return (
                Math.round(
                    price * 1.15 * 100 * (1 - discount / 100)) / 100
            )
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        /**
         * @description calcula el precio en sacoin del producto
         * @param {number} price precio original del producto en su moneda local 
         * @param {number} change valor de cambio de la moneda local
         * @returns {string} precio final
         */
        toSacoin: (price, change) => {
            if (!(price && change))
                return 0

            return (
                Math.round((price / change) * 1.15 * 100) / 100)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        /**
         * @description calcula el precio en sacoin del producto con el descuento
         * @param {number} price precio original del producto en su moneda local 
         * @param {number} change valor de cambio de la moneda local
         * @param {number} discount descuento a aplicar (descuento <= 1)
         * @returns {string} precio final con decuento
         */
        toSacoinWDiscount: (price, change, discount) => {
            if (!(price && change))
                return 0

            return (
                Math.round((price / change) * 1.15 * 100 * (1 - discount / 100)) / 100)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }

    }
}